module.exports = __webpack_public_path__ + "img/dk.37a18658.svg";